<template>
    <el-dialog
        :visible.sync="isVisible"
        width="600px"
        :close-on-click-modal="false"
    >
        <div
            class="dialog-title"
            slot="title"
        >
            编辑分类信息
        </div>
        <el-form
            :model="form"
            label-position="left"
            ref="form"
        >
            <el-form-item label="名称">
                <el-input
                    v-model="form.name"
                    autocomplete="off"
                ></el-input>
            </el-form-item>
            <el-form-item label="图标">
                <el-input
                    v-model="form.icon"
                    autocomplete="off"
                    placeholder="图标数据请不要修改"
                ></el-input>
            </el-form-item>
            <el-form-item label="状态">
                <el-checkbox v-model="form.is_enabled">启用</el-checkbox>
            </el-form-item>
        </el-form>

        <div
            slot="footer"
            class="dialog-footer"
        >
            <el-button
                @click="hide"
                round
            >关 闭</el-button>
            <el-button
                type="primary"
                @click="save"
                round
                :loading="isProcessing"
            >提 交</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    data: function() {
        return {
            isProcessing: false,
            isVisible: false,
            form: {
                name: null,
                icon: null,
                category: 'technique',
                is_enabled: true
            }
        };
    },
    methods: {
        show(domain) {
            if (domain) {
                this.form.id = domain.id;
                this.form.name = domain.name;
                this.form.icon = domain.icon;
                this.form.is_enabled = domain.is_enabled;
            } else {
                delete this.form.id;
                this.form.name = null;
                this.form.icon = null;
                this.form.is_enabled = true;
            }
            this.isVisible = true;
        },
        hide() {
            this.isVisible = false;
        },
        save() {
            this.isProcessing = true;
            this.$ox
                .service("domain")
                .save(this.form)
                .then(res => {
                    this.$notify.success({
                        title: "操作成功",
                        message: `分类“${this.form.name}”已保存`
                    });
                    this.hide();
                    this.$refs.form.resetFields();
                    this.$refs.form.clearValidate();
                    this.$emit("success", res);
                })
                .catch(err => {
                    this.$emit("error", err);
                    this.$notify.error({
                        title: "操作失败",
                        message: "请与系统维护人员联系"
                    });
                })
                .finally(() => {
                    this.isProcessing = false;
                });
        }
    }
};
</script>

<style  scoped>
.dialog-title {
    margin-bottom: 25px;
    font-size: 24px;
}
</style>